export default __webpack_public_path__ + "static/media/simulation_testseriesM.444df58b.png";